// import BottomDrawer from "../../common/drawer/bottomDrawer";
// import { useState } from "react";
// import photofolder from "../../../assets/images/photofolder.png";
// import folderframe from "../../../assets/images/folderframe.png";
// import FileAndFolderAction from "./fileAndFolderAction";
// import { FolderDetails } from "./folderDetails";
// import { folderShareList } from "../../../../services/workspace/photos.service";

// const Folder = ({
//   folder,
//   onEdit,
//   onView,
//   onDelete,
//   onShare,
//   isStudent = false,
// }) => {
//   const [isOpenSheet, setIsOpenSheet] = useState(false);
//   const [selectedFolder, setSelectedFolder] = useState(null);

//   const getShareList = async (folder) => {
//     return await folderShareList(folder?.uuid);
//   };

//   const onDetails = async (folder) => {
//     const res = await getShareList(folder);

//     if (res) {
//       setSelectedFolder({ ...folder, shareList: res });
//       setIsOpenSheet(true);
//     }
//   };

//   return (
//     <div className="rounded-md flex justify-between items-center bg-primary-50 relative hover:bg-primary-100 group">
//       <div
//         className="flex flex-col gap-2 p-2 cursor-pointer flex-1 font-normal"
//         onClick={() => onView(folder)}
//       >
//         <div className="text-primary-950 text-[100px] w-full flex justify-center">
//           <div className="relative">
//             {/* <FcOpenedFolder /> */}
//             {folder.is_owner ? (
//               <img src={photofolder} alt="" className="w-24 h-24" />
//             ) : (
//               <img src={folderframe} alt="" className="w-24 h-24" />
//             )}
//             {folder.documents_count > 0 ? (
//               <div className="text-[10px] font-medium absolute bottom-4 right-3 flexCenter bg-primary-50 w-7 h-4 rounded-full">
//                 <p>{folder.documents_count}</p>
//               </div>
//             ) : (
//               ""
//             )}
//           </div>
//         </div>
//         <div className="flex flex-row">
//           <h3 className=" text-primary-950 text-cs capitalize w-full text-center max-w-28 mx-auto truncate">
//             {folder.name}
//           </h3>

//           <FileAndFolderAction
//             doc={folder}
//             onDelete={onDelete}
//             onRename={onEdit}
//             onDetails={onDetails}
//             onView={onView}
//             onShare={onShare}
//           />
//         </div>
//       </div>
//       <BottomDrawer
//         isOpen={isOpenSheet}
//         setIsOpen={setIsOpenSheet}
//         title="Details"
//         classNames="!w-[540px]"
//         position="right"
//       >
//         {selectedFolder && <FolderDetails folder={selectedFolder} />}
//       </BottomDrawer>
//     </div>
//   );
// };

// export default Folder;

import BottomDrawer from "../../common/drawer/bottomDrawer";
import { useState } from "react";
import FileAndFolderAction from "./fileAndFolderAction";
import { FolderDetails } from "./folderDetails";
import { FcFolder } from "react-icons/fc";
import { folderFullDetail } from "../../../../services/workspace/photos.service";

const Folder = ({ folder, onEdit, onView, onDelete, onShare }) => {
  const [isOpenSheet, setIsOpenSheet] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState(null);

  const onDetails = async (folder) => {
    const res = await folderFullDetail(folder?.uuid, {with:"folderUsers"});
    if (res) {
      setSelectedFolder( res.folder );
      setIsOpenSheet(true);
    }
  };

  return (
    <div className="pt-6 ">
      <div className="bg-light rounded-b-md rounded-r-md transition p-4 pt-2 flex flex-col gap-1 w-[170px] relative">
        <div className="bg-light absolute -top-5 rounded-t-md left-0 h-5 w-20"></div>
        {/* Icon */}
        <div className="flex justify-between items-start">
          <div
            className="flex items-center justify-center cursor-pointer w-10 h-10 rounded-full bg-theme/10"
            onClick={() => onView(folder)}
          >
            {/* Example folder icon */}
            <span className="text-2xl"><FcFolder /></span>
          </div>

          {/* Actions (3 dots menu) */}
          <FileAndFolderAction
            doc={folder}
            onDelete={onDelete}
            onRename={onEdit}
            onDetails={onDetails}
            onView={onView}
            onShare={onShare}
          />
        </div>

        {/* Folder Name */}
        <h3
          className="text-primary-950 font-medium text-sm truncate cursor-pointer"
          onClick={() => onView(folder)}
        >
          {folder.name}
        </h3>

        {/* Item Count */}
        <p className="text-gray-500 text-xs">{folder.documents_count} Items</p>

        {/* Drawer */}
        <BottomDrawer
          isOpen={isOpenSheet}
          setIsOpen={setIsOpenSheet}
          title="Details"
          classNames="!w-[540px]"
          position="right"
        >
          {selectedFolder && <FolderDetails folder={selectedFolder} />}
        </BottomDrawer>
      </div>
    </div>
  );
};

export default Folder;
